import TimelineMessageModel from '@/common/models/timeline-message-model';
import CommentMessage from '@/components/timeline/components/messages/comment-message';
import EmailMessage from '@/components/timeline/components/messages/email-message/email-message';
import GenericMessage from '@/components/timeline/components/messages/generic-message/generic-message';

const map = {
    [TimelineMessageModel.Types.gatewayAccountCommentCreated]: CommentMessage,
    [TimelineMessageModel.Types.timelineCommentCreated]: CommentMessage,
    [TimelineMessageModel.Types.customerCommentCreated]: CommentMessage,
    [TimelineMessageModel.Types.emailMessageSent]: EmailMessage,
};


export default function getMessageComponentByType(type) {
    return map[type] || GenericMessage;
}
